<div class="bannerWrap px-0 md:px-[24px]">
    <div class="maxContainerWidth mb-[7%] top-[64px] md:top-[114px]">
        <div class="relative">
            <div class="absolute left-[-160px] top-[-18rem]  md:top-[-16rem]">
                <img class="w-[85%] md:w-full" src="assets/images/home/bg-gradient.png" alt="">
            </div>
            <div class="contentWrap relative z-10 flex flex-col gap-2 max-h-[350px]">
                <div class="">
                    <div class="flex flex-col">
                        <h2 class="text-gradient "> PostEx cash on delivery </h2>
                        <h1 class="mb-3 mt-2"> Upfront payment on Cash on Delivery orders. </h1>
                        <p class="text-sm text-white max-w-[435px]">Get your COD payments upfront and scale your business with PostEx—no more waiting for weeks!</p>
                    </div>
                    <div class="placeValue grid grid-cols-2 md:hidden px-3 items-center md:justify-around mt-8 md:mt-5  mb-[8rem]">
                        <div class="paymentMode lg:w-[435px] md:gap-3 flex xl:flex-row flex-col border-s border-r justify-center md:justify-start items-center border-[#3F3D56]">
                            <h3> 25,000+ </h3>
                            <p class="text-center"> Happy & Growing Partners </p>
                        </div>
                        <div class="destination p-[47px] lg:p-[0px] lg:min-w-[453px] flex xl:flex-row flex-col border-r justify-center items-center md:gap-4 border-[#3F3D56]">
                            <h3> 600+ </h3>
                            <p class="text-center"> Destinations </p>
                        </div>
                        <div class="flex my-10 md:my-0 mx-4 md:mx-0 min-w-[200px] xl:min-w-[453px] justify-start items-center border-[#3F3D56]">
                            <button class="bg-[#00DF9A] py-4 px-8 font-semibold text-sm leading-[18px] rounded-full">Contact Sales</button>
                        </div>
                    </div>
                    <div class="mapWrap max-w-[640px] md:pb-20 pb-20">
                        <img src="assets/video/map-video-2.gif" alt="" class="relative" width="1000">
                        <!-- <video class="relative" width="1000" style="right:-120px" src="assets/video/map-video-2.mp4" [muted]="'muted'" loop autoplay></video> -->
                    </div>
                </div>
            </div>
            <div class="placeValue hidden  md:flex px-3 items-center md:justify-around pb-20  md:mt-[10rem] mb-[8rem]">
                <div class="paymentMode lg:w-[435px] md:gap-3 flex xl:flex-row flex-col border-s border-r justify-center md:justify-start items-center border-[#3F3D56]">
                    <h3> 25,000+ </h3>
                    <p class="text-center"> Happy & Growing Partners </p>
                </div>
                <div class="destination p-[47px] lg:p-[0px] lg:min-w-[453px] flex xl:flex-row flex-col border-r justify-center items-center md:gap-4 border-[#3F3D56]">
                    <h3> 600+ </h3>
                    <p class="text-center"> Destinations </p>
                </div>
                <div class="flex my-10 md:my-0 mx-4 md:mx-0 min-w-[200px] xl:min-w-[453px] justify-start items-center border-[#3F3D56]">
                    <button class="bg-[#00DF9A] py-4 px-8 font-semibold text-sm leading-[18px] rounded-full">Contact Sales</button>
                </div>
            </div>
        </div>
    </div>